"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ToastSeverities = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
  SUCCESS: 'success'
};
var _default = exports.default = ToastSeverities;



//////////////////
// WEBPACK FOOTER
// ./~/primevue/api/ToastSeverity.js
// module id = 1212
// module chunks = 0